<script>
  import { onMount } from "svelte";
  import {
    addHash,
    decorateProject,
    decorateTransaction,
    transferTypes,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, goTo, id, tab } = $props();

  const transferIcons = {
    1: "fas fa-money-check-alt",
    2: "fas fa-piggy-bank",
    3: "fas fa-hand-holding-usd",
  };

  let project = $state(null);
  let members = $state([]);
  let projectTransactions = $state([]);
  let sumIn = $state(0);
  let sumOut = $state(0);
  let activeTab = $state(tab || 1);
  let sortTypeTr = $state(loadPersisted("project-detail", "sortTypeTr", "data"));
  let sortReverseTr = $state(loadPersisted("project-detail", "sortReverseTr", false));
  let currentPageTr = $state(1);
  const itemsPerPage = 10;

  $effect(() => {
    savePersisted("project-detail", "sortTypeTr", sortTypeTr);
    savePersisted("project-detail", "sortReverseTr", sortReverseTr);
  });

  onMount(() => {
    Promise.all([
      http.get("/api/projekt.php?id=" + id),
      http.get("/api/transakcja.php?idpr=" + id),
      http.get("/api/czlonek.php"),
    ]).then(
      ([projectResponse, transactionsResponse, membersResponse]) => {
        if (
          projectResponse.data.status == 200 &&
          transactionsResponse.data.status == 200 &&
          membersResponse.data.status == 200
        ) {
          const projects = addHash(projectResponse.data.records, "idpr");
          members = addHash(membersResponse.data.records, "idcz");
          decorateProject(projects[0], members);
          project = projects[0];

          const transactions = transactionsResponse.data.records;
          let totalIn = 0;
          let totalOut = 0;
          for (const transaction of transactions) {
            decorateTransaction(transaction, members, projects, transferTypes);
            if (transaction.kwota < 0) {
              totalOut += -transaction.kwota;
            } else {
              totalIn += transaction.kwota;
            }
          }
          projectTransactions = transactions;
          sumIn = totalIn;
          sumOut = totalOut;
        } else {
          alert(
            "Błąd: " +
              projectResponse.data.message +
              ", " +
              transactionsResponse.data.message +
              ", " +
              membersResponse.data.message,
          );
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  function deleteProject() {
    if (confirm("Skasować projekt " + project.nazwa + "?")) {
      http.delete("/api/projekt.php?id=" + id).then(
        (response) => {
          if (response.data.status == 200) {
            toastr.info("Skasowano projekt " + project.nazwa);
            goTo("main");
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }

  function updateTabs(newTab) {
    activeTab = newTab;
  }

  function setSortTr(field) {
    if (sortTypeTr === field) {
      sortReverseTr = !sortReverseTr;
    } else {
      sortTypeTr = field;
      sortReverseTr = false;
    }
  }

  let sortedTransactions = $derived(
    localeOrderBy(projectTransactions, sortTypeTr, sortReverseTr),
  );
  let totalItemsTr = $derived(projectTransactions.length);
  let numPagesTr = $derived(Math.max(1, Math.ceil(totalItemsTr / itemsPerPage)));
  let pagedTransactions = $derived(slice(sortedTransactions, itemsPerPage, currentPageTr));
</script>

{#if project}
<h3>Projekt: {project.nazwa}
<div class="btn-toolbar pull-right">
    <button class="btn btn-sm  btn-danger pull-right" onclick={deleteProject}><i class="fas fa-trash" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Skasuj</span></button>
    <a class="btn btn-primary btn-sm pull-right" href={"/project-edit/" + id}><i class="fas fa-edit" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Edytuj</span></a>
    <a class="btn btn-primary btn-sm pull-right" href="/project-edit/-1"><i class="fas fa-plus" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Dodaj nowy projekt...</span></a>
    <a class="btn btn-primary btn-sm pull-right" href="/projects"><i class="fas fa-chevron-left" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Powrót</span></a>
</div>
</h3>
<div class="clearfix"></div>
<div class="text-left"><small>
<i class="fa fa-random" aria-hidden="true"></i>
Ten projekt jest skojarzony z {projectTransactions.length} przelewami na łączną sumę {sumIn} (wpływy) i {sumOut} (wypłaty).
</small><p></p></div>

<div>
<ul class="nav nav-tabs">
  	<li class={activeTab==1 ? "active" : ""} onclick={() => updateTabs(1)}><a href="#" onclick={(e) => e.preventDefault()}>Info</a></li>
	<li class={activeTab==2 ? "active" : ""} onclick={() => updateTabs(2)}><a href="#" onclick={(e) => e.preventDefault()}>Przelewy</a></li>
</ul>
</div>

{#if activeTab==1}
<div>
    <table class="table table-condensed table-hover table-striped">
        <thead class="thead-default">
          <tr>
              <th>
              Dane
              </th>
              <th>
              Wartości
              </th>
          </tr>
        </thead>
        <tbody>
            <tr>
              <td>
              Unikalny identyfikator:
              </td>
              <td>
              {project.idpr}
              </td>
            </tr>
          <tr>
            <td>
            Nazwa
            </td>
            <td>
            {project.nazwa}
            </td>
          </tr>
          <tr>
            <td>
            Pełna nazwa:
            </td>
            <td>
            {project.nazwa_dl}
            </td>
          </tr>
          <tr>
            <td>
            Data początkowa:
            </td>
            <td>
            {project.data_od}
            </td>
          </tr>
          <tr>
            <td>
            Data końcowa:
            </td>
            <td>
            {project.data_do}
            </td>
          </tr>
    	  <tr>
            <td>
            Kwota:
            </td>
            <td>
            {project.kwota} {project.waluta}
            </td>
          </tr>
          <tr>
            <td>
            Osoba koordynująca:
            </td>
            <td>
            <a href={"/member-detail/" + project.koord}>{project.koord_text}</a>
            </td>
          </tr>
          <tr>
            <td>
            Dodatkowe informacje:
            </td>
            <td>
            <pre>{project.info}</pre>
            </td>
          </tr>
        </tbody>
    </table>
</div>
{/if}
{#if activeTab==2}
<div>
    <table class="table table-condensed table-hover table-striped">

        <thead class="thead-default">
    	  <tr>
    		<th>
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("data"); }}>
    		  Data
    		{#if sortTypeTr == "data" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "data" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    		<th>
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("opis"); }}>
    		  Opis transakcji
    		  {#if sortTypeTr == "opis" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "opis" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    		<th>
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("kwota"); }}>
    		  Kwota
    		  {#if sortTypeTr == "kwota" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "kwota" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    		<th class="hidden-xs hidden-sm hidden-md">
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("typ_text"); }}>
    		  Typ
    		  {#if sortTypeTr == "typ_text" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "typ_text" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    		<th class="hidden-xs hidden-sm">
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("idcz_sort_text"); }}>
    		  Osoba
    		  {#if sortTypeTr == "idcz_sort_text" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "idcz_sort_text" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    		<th class="hidden-xs hidden-sm hidden-md">
    		  <a href="#" onclick={(e) => { e.preventDefault(); setSortTr("info"); }}>
    		  Info
    		  {#if sortTypeTr == "info" && !sortReverseTr}<span class="fa fa-caret-down"></span>{/if}
    		  {#if sortTypeTr == "info" && sortReverseTr}<span class="fa fa-caret-up"></span>{/if}
    		  </a>
    		</th>
    	  </tr>
    	</thead>

    	<tbody>
    	  {#each pagedTransactions as ts}
    	  <tr>
    		<td>
    		<i class="{transferIcons[ts.typ]} fa-lg fa-fw" aria-hidden="true" style="margin: 6px 0px 8px 0px;"></i>&nbsp;&nbsp;{ts.data}
    		</td>
    		<td>
    			{ts.opis}
    			<div class="small text-muted">
    				<span><i class="fas fa-id-badge fa-fw" aria-hidden="true"></i>{ts.kontrahent}</span>
    			</div>
    			<div>
    				{#if ts.idcz_text}<span class="visible-xs visible-sm small text-muted"><i class="fas fa-user fa-fw" aria-hidden="true"></i><a href={"/member-detail/" + ts.idcz} title="Podgląd danych osoby">{ts.idcz_text}</a></span>{/if}
    			</div>
    		</td>
    		<td>
    		{ts.kwota}
    		</td>
    		<td class="hidden-xs hidden-sm hidden-md">
    		{ts.typ_text}
    		</td>
    		<td class="hidden-xs hidden-sm">
    			<a href={"/member-detail/" + ts.idcz} title="Podgląd danych osoby">{ts.idcz_text}</a>
    		</td>
    		<td class="hidden-xs hidden-sm hidden-md">
    		{ts.info}
    		</td>
    	  </tr>
    	  {/each}
    	</tbody>

	</table>
    <div id="footer">
        <Pagination {currentPageTr} {numPagesTr} onPageChange={(page) => currentPageTr = page}/>
    </div>

</div>
{/if}
{/if}
